import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonTypeEnum } from '../../enums/buttonType.enum';

@Component({
  selector: 'app-button',
  imports: [CommonModule],
  templateUrl: './app-button.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./app-button.component.scss'],
})
export class AppButtonComponent {
  @Input({ required: true }) buttonType!: ButtonTypeEnum;
  @Input({ required: true }) buttonLabel!: string;
  @Input() isIntegratorButton: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() icon!: string;

  protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
